import React from "react";
import { styled } from '@mui/material/styles';
import { makeStyles } from "@mui/material/styles";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { blue } from "@mui/material/colors";
import useStudents from "../../hooks/useStudents";
import { parseLine } from "../../helpers/parser";
import IconButton from "@mui/material/IconButton";
import green from "@mui/material/colors/green";

const PREFIX = 'AssignStudentsDialog';

const classes = {
  avatar: `${PREFIX}-avatar`,
  dialog: `${PREFIX}-dialog`,
  checkmark: `${PREFIX}-checkmark`
};

const StyledDialog = styled(Dialog)({
  [`& .${classes.avatar}`]: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  [`&.${classes.dialog}`]: {
    maxHeight: 560,
  },
  [`& .${classes.checkmark}`]: {
    color: green[500],
  },
});

type Props = {
  line: string;
  semester: string;
  handleCancel: () => void;
  handleAssign: (ids: string[]) => void;
  handleUnassign: (ids: string[]) => void;
  open: boolean;
  subjectId: string;
};
const AssignStudentsDialog: React.FC<Props> = ({
  line,
  semester,
  handleCancel,
  handleAssign,
  handleUnassign,
  open,
  subjectId,
}) => {
  const students = useStudents({ line, semester });

  return (
    <StyledDialog
      onClose={handleCancel}
      aria-labelledby="simple-dialog-title"
      open={open}
      className={classes.dialog}
    >
      <DialogTitle id="simple-dialog-title">
        {parseLine(line)} - {semester}
      </DialogTitle>
      <List>
        {students.map((student) => {
          const name = `${student.firstName} ${student.lastName}`;
          const isAssigned = student.examSubjects.includes(subjectId);
          return (
            <ListItem key={student.id}>
              <ListItemAvatar>
                <IconButton
                  onClick={() =>
                    isAssigned
                      ? handleUnassign([student.id])
                      : handleAssign([student.id])
                  }
                >
                  {isAssigned ? (
                    <CheckCircleOutlineIcon className={classes.checkmark} />
                  ) : (
                    <RadioButtonUncheckedIcon />
                  )}
                </IconButton>
              </ListItemAvatar>
              <ListItemText primary={name} />
            </ListItem>
          );
        })}
      </List>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          OK
        </Button>
        <Button
          onClick={() => {
            handleAssign(students.map((s) => s.id));
          }}
          color="primary"
          variant="contained"
          autoFocus
        >
          Tildel
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default AssignStudentsDialog;
